import { Component, OnInit } from '@angular/core';

import { CompanyService } from './company.service';
import { Router } from '@angular/router';
import { ConfirmOperationComponent } from '../../../@theme/components/confirm-operation/confirm-operation.component';
import { NbDialogService, NbToastrService, NbGlobalPhysicalPosition } from '@nebular/theme';
import { GlobalParameterService } from '../global-parameter.service';

@Component({
  selector: 'ngx-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class CompanyComponent implements OnInit {

  public companies = [];

  payment: any = {};

  settings = {
    actions: {
      columnTitle: 'Ações',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'user',
          title: '<i class="nb-gear"></i>',
        }
      ]
    },
    mode: 'external',
    columns: {
      id: {
        title: 'ID',
        type: 'string',
        filter: false
      },
      name: {
        title: 'Nome',
        type: 'string',
      },
      amountUser: {
        title: 'Quantidade de usuários ativos',
        type: 'string',
      },
      plan: {
        title: 'Plano',
        type: 'string',
      },
      situationPayment: {
        title: 'Situação do pagamento',
        type: 'string',
      },
      frequency: {
        title: 'Frequência',
        type: 'string',
      },
      createdDate: {
        title: 'Data de criação',
        valuePrepareFunction: (createdDate) => {
          return new Date(createdDate).toLocaleDateString('pt-BR');
        },
      },
    },
    noDataMessage: 'Nenhum registro encontrado',
  };

  constructor(private companyService: CompanyService,
    private router: Router,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
    private globalParameterService: GlobalParameterService) {

  }

  ngOnInit(): void {
    this.getAllCompanies();
    this.getGlobalParameter();
  }

  saveParameter() {
    this.globalParameterService.create(this.payment).toPromise().then(result => {
      location.reload();
    });
  }

  getGlobalParameter() {
    this.globalParameterService.find().toPromise().then(result => {
      this.payment = result.body;
    });
  }

  getAllCompanies() {
    this.companyService.query().toPromise().then(response => {
      this.companies = response.body;
    });
  }

  openCreateDialog() {
    this.router.navigate(['pages/admin/company', 'create']);
  }

  openEditDialog(event): void {
    this.router.navigate(['pages/admin/company', event.data.id]);
  }

  onDeleteConfirm(event): void {
    this.dialogService.open(ConfirmOperationComponent, {
      closeOnBackdropClick: false,
      context: {
        title: 'Excluir Empresa',
        text: `Você realmente deseja excluir a empresa ${event.data.name} ?`,
        accent: 'danger',
        force: true,
      },
    }).onClose.subscribe(response => response.confirmed && this.delete(event.data.id, response.force));
  }

  delete(id, force) {
    this.companyService.delete(id, force).toPromise().then(response => {
      this.toastrService.show('Empresa', 'Excluído com sucesso',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.getAllCompanies();
    }).catch(err => {
      this.toastrService.show('Empresa', err.error.detail,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });
  }

  onCustom(event) {
    if (event.action == 'user') {
      this.router.navigate(['pages/internal-admin/company', event.data.id]);
    }
  }

}
